<template>
  <v-layout column>
    <vbt-search
      v-model="searchData"
      :items="searchFieldsConfig"
      @reset="onResetSearch"
      @search="onSearch"
    />

    <vbt-content-box
      :loading="isLoading"
      :loading-error="loadingError"
      :no-content="noContent"
      :go-back-btn="goBack"
      title="Information"
    >
      <vbt-table
        :headers="headers"
        :items="tokens"
        show-details-action
        @click:details="openTokenViewer"
      >
        <template #created="{ item: { created } }">
          {{ formatDisplayDate(created) }}
        </template>
      </vbt-table>

      <vbt-pagination
        v-model="pageNum"
        :items-count="pagedItemsCount"
      />
    </vbt-content-box>

    <ums-token-viewer
      v-model="tokenDialog"
      :payload="tokenPayloadStr"
    />
  </v-layout>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import { useDataLoading, usePagination, useSearch } from '@mixins/factories';

import { formatDisplayDate } from '@helpers';

import { namespace as EnumsNamespace } from '@store/modules/enums.types';
import { namespace as TenantsNamespace, ActionTypes as TenantsActionTypes } from '@modules/tenants/store.types';
import { namespace as UsersNamespace, ActionTypes as UsersActionTypes } from '@modules/users/store.types';

import { namespace as TokensNamespace, ActionTypes as TokensActionTypes } from '../store.types';

import UmsTokenViewer from '../_components/UmsTokenViewer.vue';

const dataLoadingOptions = {
  getterName: TokensActionTypes.GET_TOKENS,
  contentName: 'tokens',
};
const paginationOptions = { contentName: 'tokens' };
const searchOptions = {
  initialSearchDataStates: [
    'user', 'service', 'type',
  ],
};

const headers = Object.freeze([
  { text: 'User', value: 'user' },
  { text: 'Service', value: 'service' },
  { text: 'Creation Type', value: 'type' },
  { text: 'Created Date', value: 'created' },
]);

export default {
  name: 'UmsTokens',
  components: {
    UmsTokenViewer,
  },
  mixins: [
    useDataLoading(dataLoadingOptions),
    usePagination(paginationOptions),
    useSearch(searchOptions),
  ],
  data: () => ({
    headers,
    tokenDialog: false,
    tokenPayloadStr: '',
  }),
  computed: {
    ...mapState(TokensNamespace, ['tokens']),
    ...mapState(UsersNamespace, ['usersNamesAutocomplete']),
    ...mapState(EnumsNamespace, {
      tokenTypesOptions: ({ enums: { tokenType: items } }) => (items || [])
        .map((v) => ({ text: v, value: v })),
    }),
    ...mapState(TenantsNamespace, {
      tenantsOptions: ({ allTenants }) => allTenants
        .map(({ name: v }) => ({ value: v, text: v })),
    }),
    searchFieldsConfig() {
      return [
        {
          flex: 'lg4',
          value: 'user',
          label: 'User',
          type: 'autocomplete',
          placeholder: 'Start typing...',
          items: this.usersNamesAutocomplete,
          callback: this.getUsersNamesAutocomplete,
        },
        {
          flex: 'lg4',
          value: 'service',
          label: 'Service',
          type: 'select',
          items: this.tenantsOptions,
        },
        {
          flex: 'lg4',
          value: 'type',
          label: 'Creation type',
          type: 'select',
          items: this.tokenTypesOptions,
        },
      ];
    },
  },
  created() {
    this.getTenants();
  },
  methods: {
    ...mapActions(TokensNamespace, [TokensActionTypes.GET_TOKENS]),
    ...mapActions(TenantsNamespace, {
      getTenants: TenantsActionTypes.GET_ALL_TENANTS,
    }),
    ...mapActions(UsersNamespace, {
      getUsersNamesAutocomplete: UsersActionTypes.GET_USERS_NAMES_AUTOCOMPLETE,
    }),
    formatDisplayDate,
    openTokenViewer({ payload }) {
      this.tokenPayloadStr = payload;
      this.tokenDialog = true;
    },
  },
};
</script>
